// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wpgb","tabsBox":"styles_tabsBox__FeGTs","createButton":"styles_createButton__1T-zF"};